import React, { useEffect, useState, memo, Suspense } from "react";
//import { pretendModelData } from "../pretendModelData";
import ModelArchiveThumbs from "./ModelArchiveThumbs";
import ModelArchivePhotoThumb from "./ModelArchivePhotoThumb";
import ModelLockedUpdate from "./modelarchive/ModelLockedUpdate";
import PopUp from "../components/PopUp";
import GiveTip from "../components/GiveTip";
import Constants from "../constants/Constants";
import FavLibNav from "./modelarchive/FavLibNav";
import RegNav from "./modelarchive/RegNav";
import Loader from "./Loader";
import RequestCustom from "./modelarchive/RequestCustom";
import Live from "./modelarchive/Live";
import "../lightbox.css";
import AudioUpdate from "./modelarchive/AudioUpdate";
import UpsellBtn from "./modelarchive/UpsellBtn";
const PurchaseAVideo = React.lazy(() =>
  import("./modelarchive/PurchaseAVideo")
);
const PlayAudio = React.lazy(() => import("./modelarchive/PlayAudio"));

const ModelArchive = (props) => {
  const {
    dispatch,
    pos,
    scrollSite,
    modelName,
    avatar,
    nvgMember,
    library,
    actives,
    biller,
  } = props;
  const [updates, setUpdates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [giveTip, setGiveTip] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [search, setSearch] = useState(false);
  const [quickSearch, setQuickSearch] = useState("");
  const [playAudio, setPlayAudio] = useState(0);
  const [buyVideo, setBuyVideo] = useState({});
  const [model, setModel] = useState({});
  const [pageState, setPageState] = useState("thumbs");
  const [buyLockedVideo, setBuyLockedVideo] = useState(false);

  const handleBuyingLockedVideo = (video) => {
    setBuyLockedVideo(true);
    setBuyVideo(video);
  };
  const handleCloseSearch = () => {
    setQuickSearch("");
    setSearch(false);
  };
  const audioJoin = () => {
    setModel(updates.site);
    setPlayAudio(0);
  };
  const join = (modelVar) => {
    setModel(modelVar);
  };
  useEffect(() => {
    if (pos > 0 && scrollSite === modelName) {
      setTimeout(() => window.scrollTo({ top: pos, left: 0 }), 900);
    }
    // return () => {
    //   let gah =
    //     (window.pageYOffset || document.documentElement.scrollTop) -
    //     (document.documentElement.clientTop || 0);
    //   console.log("1", window.pageYOffset);
    //   console.log("2", document.documentElement.scrollTop);
    //   console.log("3", document.documentElement.clientTop);
    //   console.log("what in the fuck", gah);

    //   dispatch({
    //     type: "scrollTo",
    //     site: modelName,
    //     payload:
    //       (window.pageYOffset || document.documentElement.scrollTop) -
    //       (document.documentElement.clientTop || 0)
    //   });
    // };
  }, [pos, modelName, scrollSite]);
  useEffect(() => {
    const cacheBust =
      modelName === "favorites" || modelName === "library" ? Date.now() : "";
    fetch(
      `${Constants.API}model-archive.php?site=${modelName}&cb=${cacheBust}`,
      {
        credentials: "include",
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if ("error" in res) {
          console.log("need to handle this error", res);
        } else {
          setUpdates(res);
          if (
            (modelName !== "favorites" || modelName !== "library") &&
            actives.includes(res.site.id)
          ) {
            setIsActive(true);
          }
          setIsLoading(false);
        }
      });
    // setUpdates(pretendModelData);
    // setIsLoading(false);
    // setTimeout(() => {
    //   setUpdates(pretendModelData);
    //   setIsLoading(false);
    // }, 4000);
  }, [modelName, actives]);
  useEffect(() => {
    return () => {
      if (quickSearch.trim() !== "") {
        fetch(`${Constants.API}ltst.php?t=${quickSearch}`, {
          credentials: "include",
        });
      }
    };
  }, [quickSearch]);
  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className="general_page">
      <div className="user_panel">
        <div className="flex">
          <div className="avatar">
            <img
              src={
                modelName === "favorites" || modelName === "library"
                  ? `https://static.addfriends.com/vip/avatars/${avatar}.jpg`
                  : `https://addfriends.com/images/sites/${updates.site.site_url}.jpg`
              }
              alt=""
            />
          </div>
          <div className="information">
            <div className="name">
              <strong>{updates.site.site_name.split(" ")[0]}</strong>
              {updates.site.site_name.split(" ")[1]
                ? updates.site.site_name.split(" ")[1]
                : ""}
              {updates.site.site_name.split(" ")[2]
                ? updates.site.site_name.split(" ")[2]
                : ""}
            </div>
            {modelName === "favorites" || modelName === "library" ? null : (
              <ul className="information_tools">
                <li className="item">
                  {Math.round(10 * (updates.site.views / 1000)) / 10}k views
                </li>
                <li className="item">{updates.site.videos} vids</li>
                <li className="item">{updates.site.likes} likes</li>
              </ul>
            )}
            {modelName === "favorites" ||
            modelName === "library" ? null : updates.site.id === "7" ? (
              <UpsellBtn
                dispatch={dispatch}
                biller={biller}
                nvgMember={nvgMember}
              />
            ) : (
              <div
                className="tipMe"
                onClick={() => setGiveTip((prev) => !prev)}
              >
                Send Tip
              </div>
            )}
          </div>
          {updates.site.news ? (
            <div className="siteNews">{updates.site.news}</div>
          ) : null}
        </div>
        {modelName === "favorites" || modelName === "library" ? (
          <FavLibNav modelName={modelName} />
        ) : search ? (
          <div className="quickContainer">
            <input
              type="text"
              className="quickSearch"
              value={quickSearch}
              placeholder="Search Title / Tags"
              autoFocus
              onChange={(e) => {
                setQuickSearch(e.target.value.toLowerCase());
                window.scrollTo(window.scrollX, window.scrollY - 1);
                window.scrollTo(window.scrollX, window.scrollY + 1);
              }}
            />
            <div className="closeSearch" onClick={handleCloseSearch}>
              <i className="icon-close" />
            </div>
          </div>
        ) : (
          <RegNav
            pageState={pageState}
            setPageState={setPageState}
            site={updates.site}
            setSearch={setSearch}
          />
        )}
      </div>
      <div className="tab_content">
        {pageState === "thumbs" && (
          <div id="tab1" className="tab_box active">
            <div className="thumbs">
              {updates.videos
                .filter((v) => {
                  if (quickSearch === "") {
                    return true;
                  }
                  let nada = "";
                  if (v.id in updates.hashes) {
                    nada = updates.hashes[v.id];
                  }
                  return (
                    v.title.toLowerCase().includes(quickSearch) ||
                    nada.includes(quickSearch)
                  );
                })
                .map((video) => {
                  if (video.is_locked === "y") {
                    if (
                      (video.archive_type === "photo" ||
                        video.archive_type === "album") &&
                      library.includes(video.id)
                    ) {
                      return (
                        <ModelArchivePhotoThumb
                          video={video}
                          key={`lva${video.id}`}
                          tags={updates.hashes[video.id]}
                          file={updates.files[video.id][0]}
                          site={updates.site}
                          modelName={modelName}
                          actives={actives}
                          dispatch={dispatch}
                          isActive={isActive}
                          join={join}
                        />
                      );
                    }
                    if (
                      library.includes(video.id) &&
                      video.archive_type === "audio"
                    ) {
                      return (
                        <AudioUpdate
                          setPlayAudio={setPlayAudio}
                          video={video}
                          key={`audiol-${video.id}`}
                        />
                      );
                    }
                    return (
                      <ModelLockedUpdate
                        video={video}
                        key={`mlu${video.id}`}
                        tags={updates.hashes[video.id]}
                        file={updates.files[video.id][0]}
                        site={updates.site}
                        modelName={modelName}
                        dispatch={dispatch}
                        hasBought={library.includes(video.id)}
                        join={join}
                        handleBuyingLockedVideo={handleBuyingLockedVideo}
                      />
                    );
                  }
                  if (video.archive_type === "audio") {
                    return (
                      <AudioUpdate
                        setPlayAudio={setPlayAudio}
                        video={video}
                        key={`audio-${video.id}`}
                      />
                    );
                  }
                  if (
                    video.archive_type === "photo" ||
                    video.archive_type === "album"
                  ) {
                    return (
                      <ModelArchivePhotoThumb
                        video={video}
                        key={`va${video.id}`}
                        tags={updates.hashes[video.id]}
                        file={updates.files[video.id][0]}
                        site={updates.site}
                        modelName={modelName}
                        actives={actives}
                        dispatch={dispatch}
                        isActive={isActive}
                        join={join}
                      />
                    );
                  }
                  return (
                    <ModelArchiveThumbs
                      video={video}
                      key={`va${video.id}`}
                      tags={updates.hashes[video.id]}
                      file={updates.files[video.id][0]}
                      site={updates.site}
                      modelName={modelName}
                      actives={actives}
                      dispatch={dispatch}
                      isActive={isActive}
                      join={join}
                    />
                  );
                })}
            </div>
          </div>
        )}
        {pageState === "request" && <RequestCustom site={updates.site} />}
        {pageState === "live" && <Live site={updates.site} />}
      </div>
      {props.children}
      {!giveTip && Object.keys(model).length > 0 ? (
        <PopUp join={join} model={model} dispatch={dispatch} biller={biller} />
      ) : null}
      {giveTip ? (
        <GiveTip model={updates.site} setGiveTip={setGiveTip} biller={biller} />
      ) : null}
      {playAudio !== 0 && (
        <Suspense fallback={null}>
          <PlayAudio
            setPlayAudio={setPlayAudio}
            audioJoin={audioJoin}
            model={updates.site}
            id={playAudio}
          />
        </Suspense>
      )}
      {buyLockedVideo && Object.keys(buyVideo).length !== 0 && (
        <Suspense fallback={null}>
          <PurchaseAVideo
            setBuyLockedVideo={setBuyLockedVideo}
            video={buyVideo}
            biller={biller}
            dispatch={dispatch}
          />
        </Suspense>
      )}
    </div>
  );
};

export default memo(ModelArchive);
